<div id="{{dialogId}}" appDraggable dragTarget="#{{dialogId}}" dragHandle="#{{getIdForDialogHeader()}}"
     class="modal fade locationAlertDataPane in ui-draggable ui-draggable-handle" style="position: absolute; left: 50px; top: 10px; width: auto; min-width: 750px; max-width: 750px; min-height: 400px; height: auto; overflow-y: auto; max-height: 100%; display: none;"
     [class.modalInsideModal]="popupInModal == true"
     role="dialog">
  <div class="modal-dialog-sm" role="document">
    <div class="modal-content">
      <div id="{{getIdForDialogHeader()}}" class="modal-header">
        {{filterType}} FILTER
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">x</span>
        </button>
      </div>
      <div class="modal-body">
        <div style="float: right; position: relative; top: -16px; list-style-type: none">
          <span class="dropdown">
            <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            NEW FILTER <i class="fa fa-chevron-down"></i></button>
            <!-- Location Filters -->
            <ng-container *ngIf="filterType == 'LOCATIONS' && filters.locationFilters">
              <ul class="dropdown-menu">
                <ng-container *ngFor="let locationFilter of filters.locationFilters">
                  <li><a class="dropdown-toggle" (click)="selectLocationFilter(locationFilter.name)">{{ locationFilter.name }}</a></li>
                </ng-container>
              </ul>
            </ng-container>

            <!-- People Filters -->
            <ng-container *ngIf="filterType == 'PEOPLE' && filters.peopleFilters">
              <ul class="dropdown-menu">
                <ng-container *ngFor="let peopleFilter of filters.peopleFilters">
                  <li><a class="dropdown-item" (click)="selectPeopleFilter(peopleFilter.name)">{{ peopleFilter.name }}</a></li>
                </ng-container>
              </ul>
            </ng-container>

            <!-- Assets Filters -->
            <ng-container *ngIf="filterType == 'ASSETS' && filters.assetFilters">
              <ul class="dropdown-menu">
                <ng-container *ngFor="let assetFilter of filters.assetFilters">
                  <li><a class="dropdown-item" (click)="selectAssetFilter(assetFilter.name)">{{ assetFilter.name }}</a></li>
                </ng-container>
              </ul>
            </ng-container>

          </span>
        </div>


        <!-- Name -->
        <br><br>
        <div class="row">
          <div class="form-group">
            <div class="col-sm-2"><label class="labelRequired">Name</label></div>
            <div class="col-sm-10"><input class="form-control" type="text" [(ngModel)]="filter.name" /></div>
          </div>

          <!-- Properties 
          <div class="form-group">
            <div class="col-sm-12">
              <app-multi-value-widget #multiValueWidget [(data)]="filterData" [propertiesArray]="properties"></app-multi-value-widget>
            </div>
          </div>
          -->
          <div class="form-group">
            <div class="col-sm-8"></div>
            <div class="col-sm-2"><input type="radio" name="abc" [checked]="filter.connection == 'and'" (click)="filterConnectionChosen('and')"/> AND </div>
            <div class="col-sm-2"><input type="radio" name="abc" [checked]="filter.connection == 'or'" (click)="filterConnectionChosen('or')" /> OR </div>
          </div>
        </div>
      <!-- Dialog Footer -->
      <div class="modal-footer">
        <div class="form-group">
          <div class="col-sm-6" style="text-align: left"><button type="button" class="btn btn-default" (click)="deleteClicked()"><i class="fa fa-ban"></i> DELETE</button></div>
          <div class="col-sm-6" style="text-align: right"><button type="button" class="btn btn-default" (click)="cancelClicked()">
            <i class="fa fa-ban"></i> CANCEL</button>
            <button *ngIf="isNewDialog()"  (click)="createOrUpdateClicked()" class="btn btn-primary"><i class="fa fa-plus"></i> CREATE</button>
            <button *ngIf="isEditDialog()" (click)="createOrUpdateClicked()" class="btn btn-primary"><i class="fa fa-refresh"></i> UPDATE</button>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
